import basicInformation from '@backrs_ui/common-ui/src/assets/animations/basic-information.json';
import blob from '@backrs_ui/common-ui/src/assets/animations/blob.json';
import buildingIdeas from '@backrs_ui/common-ui/src/assets/animations/building-ideas.json';
import circleInParts from '@backrs_ui/common-ui/src/assets/animations/circle-in-parts.json';
import circleLoading from '@backrs_ui/common-ui/src/assets/animations/circle-loading.json';
import cloudComputing from '@backrs_ui/common-ui/src/assets/animations/cloud-computing.json';
import cloud from '@backrs_ui/common-ui/src/assets/animations/cloud.json';
import dataSync from '@backrs_ui/common-ui/src/assets/animations/data-sync.json';
import diggingForGold from '@backrs_ui/common-ui/src/assets/animations/digging-for-gold.json';
import dotsDotting from '@backrs_ui/common-ui/src/assets/animations/dots-dotting.json';
import lubavLoader from '@backrs_ui/common-ui/src/assets/animations/lubav-loader.json';
import paperMap from '@backrs_ui/common-ui/src/assets/animations/paper-map.json';
import polishing from '@backrs_ui/common-ui/src/assets/animations/polishing.json';
import pulsingCircle from '@backrs_ui/common-ui/src/assets/animations/pulsing-circle.json';
import seoAnalytics from '@backrs_ui/common-ui/src/assets/animations/seo-analytics.json';
import starburst from '@backrs_ui/common-ui/src/assets/animations/starburst.json';
import teardrop from '@backrs_ui/common-ui/src/assets/animations/teardrop.json';
import water from '@backrs_ui/common-ui/src/assets/animations/water.json';
import webSearch from '@backrs_ui/common-ui/src/assets/animations/web-search.json';
import zigzag from '@backrs_ui/common-ui/src/assets/animations/zigzag.json';

export const lottieAnimations = {
  lubavLoader,
  dotsDotting,
  pulsingCircle,
  dataSync,
  paperMap,
  diggingForGold,
  polishing,
  cloudComputing,
  basicInformation,
  buildingIdeas,
  webSearch,
  water,
  circleInParts,
  circleLoading,
  seoAnalytics,
  zigzag,
  blob,
  teardrop,
  cloud,
  starburst,
} as const;
